import React from "react";
import { Box, Link } from "@mui/material";
import { colors, fonts, gradients, layout } from "../../theme/tokens";

const ServicesCta = () => {
  return (
    <Box
      component="section"
      sx={{ pt: "30px", pb: "86px", px: { xs: "20px", md: "28px" } }}
    >
      <Box
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          textAlign: "center",
          background: "linear-gradient(135deg,#1E3A57,#0E1B2A)",
          borderRadius: "30px",
          p: { xs: "48px 28px", md: "64px 40px" },
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-90px",
            right: "-50px",
            width: "320px",
            height: "320px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle,rgba(246,166,35,.24),transparent 65%)",
          }}
        />
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              fontFamily: fonts.display,
              fontSize: "12.5px",
              fontWeight: 600,
              letterSpacing: ".2em",
              color: colors.amberDot,
            }}
          >
            READY TO GET STARTED?
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.6vw,42px)",
              lineHeight: 1.12,
              color: "#fff",
              mt: "16px",
              mb: 0,
            }}
          >
            Let's find the right solution for your business
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16.5px",
              lineHeight: 1.65,
              color: colors.footerText,
              maxWidth: "560px",
              mx: "auto",
              mt: "16px",
            }}
          >
            Every business is different. Book a consultation and our team will
            develop a strategy tailored to your specific challenges and goals.
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "14px",
              justifyContent: "center",
              flexWrap: "wrap",
              mt: "30px",
            }}
          >
            <Link
              href="/contact-us"
              underline="none"
              sx={{
                background: gradients.amber,
                color: "#fff",
                fontFamily: fonts.body,
                fontWeight: 700,
                fontSize: "15px",
                p: "15px 30px",
                borderRadius: "44px",
                boxShadow: "0 14px 32px -12px rgba(242,121,28,.7)",
                transition: "transform .25s ease",
                "&:hover": { transform: "translateY(-1px)" },
              }}
            >
              Book a Consultation
            </Link>
            <Link
              href="/about-us"
              underline="none"
              sx={{
                background: "rgba(255,255,255,.08)",
                border: "1px solid rgba(255,255,255,.2)",
                color: "#fff",
                fontFamily: fonts.body,
                fontWeight: 700,
                fontSize: "15px",
                p: "15px 30px",
                borderRadius: "44px",
              }}
            >
              Learn About Us
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ServicesCta;
